<template>
  <div class="select-store-component">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      custom-class="dialog-bind-item"
      width="600px"
      append-to-body
    >
      <el-form
        label-width="110px"
        style="width: 100%"
        :model="formData"
        ref="form"
        :rules="rules"
        size="small"
      >
        <!-- flag{{ flag }}||type{{ type }} -->
        <el-form-item
          :label="$t('lcd.Devices.Device ID')"
          prop="code"
          v-if="type == 'single'"
        >
          {{ detailData.code }}
        </el-form-item>
        <el-form-item :label="$t('devices.esl.storeName')" v-else>
          {{ storeName }}
        </el-form-item>

        <el-form-item
          :label="$t('lcd.Devices.Brightness set')"
          prop="brightness"
          v-if="flag == 'brightness'"
        >
          <el-slider style="width: 240px" v-model="formData.brightness"></el-slider>
        </el-form-item>
        <el-form-item
          :label="$t('lcd.Devices.Volume set')"
          prop="volume"
          v-else
        >
          <el-slider style="width: 240px" v-model="formData.volume"></el-slider>
        </el-form-item>
      </el-form>
      <!-- <span class="itemBtn" @click="handleDeleteBind(index)">删除</span> -->
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="handleClose('cancel')"
          style="background: #d4d4d4"
          >{{ $t("button.Cancel") }}</el-button
        >
        <el-button
          size="small"
          class="base-color-btn"
          type="success"
          @click="handleConfirm('confirm')"
          >{{ $t("button.Confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { screenSetSingle, screenSetStore } from "@/libs/api/lcd";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
export default {
  name: "selectStore",
  components: {},
  props: {
    flag: {
      type: String,
      default: "brightness",
    },
    type: {
      type: String,
      default: "",
    },
    detailData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      title: this.$t("lcd.Devices.Brightness set"),
      dialogVisible: false,
      loading: false,
      formData: {
        brightness: "",
        volume: "",
      },
      installTypeList: [],
      rules: {},
      storeName: localStorage.getItem("storeName"),
    };
  },
  created() {
    this.getEnumList();
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        console.log("打开了", typeof this.detailData.bindItem);
        if(this.type == 'store'){
          this.formData.brightness = 0
          this.formData.volume = 0
        } else {
          this.formData.brightness = this.detailData.brightness ? this.detailData.brightness: 0
          this.formData.volume = this.detailData.volume ? this.detailData.volume : 0
        }
        
        if (this.flag == "brightness") {
          this.title = this.$t("lcd.Devices.Brightness set");
        } else {
          this.title = this.$t("lcd.Devices.Volume set");
        }
      }
    },
  },
  methods: {
    getEnumList() {
      const params = {
        cateId: 50,
      };
      getCodeList(params).then((res) => {
        console.log(res);
        this.installTypeList = res.data.data;
      });
    },
    open() {
      this.dialogVisible = true;
    },

    // 取消选择
    handleClose() {
      this.bindItemList = [];
      this.dialogVisible = false;
    },
    // 点击确定
    handleConfirm() {
      let params = {
        taskTerminal: 0, // pc
      }
      if(this.flag == 'brightness'){
        params.brightness = this.formData.brightness
      } else {
        params.volume = this.formData.volume
      }
      if (this.type == "store") {
        params.storeId = localStorage.getItem("storeId")
        screenSetStore(params).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message.success(this.$t("lcd.Devices.Setting Success"));
            this.dialogVisible = false;
            this.$emit("reGetList");
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        params.screenId = this.detailData.id 
        screenSetSingle(params).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message.success(this.$t("lcd.Devices.Setting Success"));
            this.dialogVisible = false;
            this.$emit("reGetList");
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-bind-item {
  margin-top: 0 !important;
  margin-bottom: 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .el-dialog__body {
    height: 400px;
    padding: 20px;
    box-sizing: border-box;
  }
  ::v-deep
    .el-descriptions__body
    .el-descriptions__table
    .el-descriptions-item__cell {
    line-height: 28px !important;
    background-color: pink;
  }
  .select-store-bd {
    margin: 0 auto;
    width: 80%;
    ::v-deep .el-radio {
      margin-top: 5px;
      padding: 10px 0;
      width: 100%;
    }
  }
  .box {
    height: 330px;
    margin-top: 20px;
  }
  .el-table thead {
    display: none;
  }
  .el-button {
    width: 110px;
  }
  .el-tree-node__content {
    height: 45px;
  }
  .el-table td.el-table__cell {
    border: none;
    width: 100%;
  }
  .el-table td.el-table__cell > .cell {
    justify-content: flex-start;
  }
  .el-table__row {
    display: flex;
  }
  // ::v-deep .el-radio{
  //   margin-top: 5px;
  //   padding: 20px 0;
  //   width: 100%;
  // }
  ::v-deep .el-table {
    .el-table__header {
      width: 100% !important;
    }
    th.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
    td.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .is-group tr:nth-child(2) .el-checkbox {
      display: none;
    }
  }

  // 重置样式
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-dialog__footer {
    padding: 20px 0;
  }
  .el-radio {
    padding: 14px 0;
    margin-bottom: 0;
  }

  .itemBtn {
    cursor: pointer;
    color: red;
  }
}
</style>